var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import EmailOrSMSForm, { EMAIL_OR_SMS_DEFAULTS, } from "../../../Presentational/Message/EmailOrSMSForm";
import { SEND_TO_FILTER, SEND_TO_SELECTED_RECIPIENTS_ID, } from "../../../../../util/messageFormUtils";
export const MESSAGE_FORM_DEFAULTS = Object.assign(Object.assign({}, EMAIL_OR_SMS_DEFAULTS), { rbTagsAnyAll: "any", 
    // @ts-expect-error - TS2322 - Type '{ rbTagsAnyAll: string; sendToInstitutional: true; isEmail?: "true" | undefined; template?: PersonMessageTemplate | null | undefined; sendToPersonal?: boolean | undefined; ... 5 more ...; logMessage?: boolean | undefined; } | { ...; }' is not assignable to type 'Partial<MessageFormState>'.
    sendToInstitutional: true });
const _getMessageToIds = (formState) => {
    var _a, _b;
    // SET AFFILIATION IDS
    // @ts-expect-error - TS7034 - Variable 'affiliationIds' implicitly has type 'any[]' in some locations where its type cannot be determined.
    let affiliationIds = [];
    // affiliation id
    switch ((_a = formState === null || formState === void 0 ? void 0 : formState.to) === null || _a === void 0 ? void 0 : _a.value) {
        case SEND_TO_SELECTED_RECIPIENTS_ID:
            if (!((_b = formState === null || formState === void 0 ? void 0 : formState.to) === null || _b === void 0 ? void 0 : _b.isPopulation)) {
                affiliationIds = formState === null || formState === void 0 ? void 0 : formState.sendToRecipients.map((recipient) => ({
                    id: recipient.affiliationId,
                }));
            }
            break;
        default:
            affiliationIds = [];
    }
    // @ts-expect-error - TS7005 - Variable 'affiliationIds' implicitly has an 'any[]' type.
    return affiliationIds;
};
export const messageFormStateToRequest = (formState) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const request = {
        // @ts-expect-error Not sure how to fix it
        messageType: ((_a = formState.to) === null || _a === void 0 ? void 0 : _a.isPopulation)
            ? SEND_TO_FILTER
            : (_b = formState.to) === null || _b === void 0 ? void 0 : _b.value,
        fromPersonId: ((_c = formState === null || formState === void 0 ? void 0 : formState.fromEmailAddress) === null || _c === void 0 ? void 0 : _c.personId) || undefined,
        noteTypes: ((_d = formState.selectedNoteTypes) === null || _d === void 0 ? void 0 : _d.map((noteType) => ({ id: noteType.id }))) ||
            [],
        // @ts-expect-error - TS2339 - Property 'template' does not exist on type 'MessageFormState'.
        messageTemplateId: ((_e = formState.template) === null || _e === void 0 ? void 0 : _e.messageTemplateId) || "",
        includeSubscribers: formState.includeSubscribers || false,
        tagFilterMode: formState.rbTagsAnyAll,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        toTagIds: ((_f = formState.tags) === null || _f === void 0 ? void 0 : _f.map((tag) => tag.id)) || [],
        toProgramIds: ((_g = formState.toPrograms) === null || _g === void 0 ? void 0 : _g.map((program) => program.value)) || [],
        toDegreeIds: ((_h = formState.toDegrees) === null || _h === void 0 ? void 0 : _h.map((degree) => degree.value)) || [],
        toTermRiskLevelIds: ((_j = formState.persistence) === null || _j === void 0 ? void 0 : _j.map((level) => level.id)) || [],
        toCourseRiskLevelIds: ((_k = formState.toCourseRiskLevels) === null || _k === void 0 ? void 0 : _k.map((level) => level.id)) || [],
        // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type '{ id: string; }[]'.
        toCourseSectionIds: ((_l = formState.toCourseSection) === null || _l === void 0 ? void 0 : _l.map((section) => section.courseSectionId)) ||
            [],
        studentSearchPopulation: formState.to.isPopulation
            ? formState.to.value
            : null,
        populationAdHocCaseloadAffiliationIds: (_m = formState.populationAdHocCaseloads) === null || _m === void 0 ? void 0 : _m.map((person) => person.affiliationId),
        applicationStatuses: formState.applicationStatus || [],
        applicationTerms: formState.applicationTerm || [],
        attachmentsIdList: [],
        toRecipientsFromListDetail: (formState.toRecipientsFromListDetail &&
            JSON.parse(formState.toRecipientsFromListDetail)) ||
            [],
        toRecipientsFromListIds: (formState.toRecipientsFromListIds &&
            JSON.parse(formState.toRecipientsFromListIds)) ||
            [],
        // @ts-expect-error - TS2339 - Property 'subject' does not exist on type 'MessageFormState'.
        subject: formState.subject || "",
        sendAsNote: !!(formState.selectedNoteTypes && formState.selectedNoteTypes.length),
        toIds: _getMessageToIds(formState),
        logMessage: formState.logMessage,
        personType: (_o = formState.to) === null || _o === void 0 ? void 0 : _o.personType,
    };
    if (formState.isEmail === "true") {
        request.body = formState.body;
        request.sendToInstitutional = formState.sendToInstitutional;
        request.sendToPersonal = formState.sendToPersonal;
        // @ts-expect-error - TS2339 - Property 'sendAsSms' does not exist on type 'MessageRequest'.
        request.sendAsSms = false;
        // @ts-expect-error - TS2339 - Property 'inlineAttachments' does not exist on type 'MessageRequest'.
        request.inlineAttachments = formState.inlineAttachments;
    }
    if (formState.isEmail !== "true") {
        request.smsBody = formState.smsBody;
        // @ts-expect-error - TS2339 - Property 'sendAsSms' does not exist on type 'MessageRequest'.
        request.sendAsSms = true;
    }
    return request;
};
const MessageForm = (_a) => {
    var { renderAttachments } = _a, formProps = __rest(_a, ["renderAttachments"]);
    return (_jsxs(_Fragment, { children: [_jsx(EmailOrSMSForm, Object.assign({ renderAttachments: renderAttachments || null, showRecipientForm: true }, formProps)), _jsx("input", { type: "hidden", name: "id", ref: formProps.register })] }));
};
export default MessageForm;
